var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _rect5, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgLogoOsiris(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 107,
    viewBox: "0 0 90 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -30.9319,
    y: 8.90654,
    width: 28.4543,
    height: 28.3464,
    transform: "rotate(-37.254 -30.9319 8.90654)",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -39.6253,
    y: 8.17884,
    width: 41.0076,
    height: 40.244,
    transform: "rotate(-36.8014 -39.6253 8.17884)",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDasharray: "1.1 4.1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -50.6529,
    y: 6.75545,
    width: 56.3993,
    height: 56.2794,
    transform: "rotate(-37.5285 -50.6529 6.75545)",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDasharray: "1.1 4.1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -29.3278,
    y: -11.2218,
    width: 41.8398,
    height: 41.119,
    transform: "rotate(7.14074 -29.3278 -11.2218)",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.6323,
    cy: 17.4138,
    r: 1.59005,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.12856,
    cy: 36.8659,
    r: 1.59005,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -1.55908,
    y: 0.837411,
    width: 3.9687,
    height: 3.9687,
    transform: "rotate(0.790698 -1.55908 0.837411)",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4607,
    cy: 15.4422,
    r: 0.93289,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.729,
    cy: 15.179,
    r: 0.93289,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: -11.1068,
    cy: 11.5783,
    r: 45.8698,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: -11.1067,
    cy: 11.5784,
    r: 69.7249,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4351,
    cy: 67.6373,
    r: 1.73792,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: -11.1068,
    cy: 11.5785,
    r: 93.5799,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    strokeDasharray: "20.1 10.1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -34.6069,
    y1: 29.5704,
    x2: 12.183,
    y2: -6.17917,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: -29.2645,
    y1: -11.3927,
    x2: 7.27365,
    y2: 34.8714,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33.8351,
    y1: 0.610018,
    x2: 58.5444,
    y2: -4.91014,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 34.3783,
    y1: 2.972,
    x2: 44.8929,
    y2: 1.39482,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 47.8134,
    y1: 0.763191,
    x2: 64.5743,
    y2: -2.2379,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 34.6504,
    y1: 5.33704,
    x2: 69.442,
    y2: 1.39407,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 34.9239,
    y1: 7.43907,
    x2: 85.1286,
    y2: 3.98565,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 35.2011,
    y1: 10.3296,
    x2: 76.9965,
    y2: 9.80388,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 35.2081,
    y1: 13.0059,
    x2: 69.3825,
    y2: 13.7007,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 74.7715,
    y1: 13.7148,
    x2: 85.1087,
    y2: 13.7148,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 34.958,
    y1: 15.588,
    x2: 69.919,
    y2: 17.9538,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 34.7121,
    y1: 17.6917,
    x2: 85.1821,
    y2: 24.5262,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 34.1978,
    y1: 20.3229,
    x2: 68.6331,
    y2: 26.6317,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 33.6872,
    y1: 22.4287,
    x2: 66.5453,
    y2: 30.5775,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 72.8069,
    y1: 32.0652,
    x2: 83.6715,
    y2: 34.6096,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 33.174,
    y1: 24.5347,
    x2: 74.7066,
    y2: 37.1522,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 32.6615,
    y1: 26.6427,
    x2: 79.9771,
    y2: 43.9918,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 31.6229,
    y1: 29.0131,
    x2: 63.9552,
    y2: 42.9449,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 30.5795,
    y1: 31.383,
    x2: 40.5683,
    y2: 36.1145,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 43.1186,
    y1: 37.3275,
    x2: 58.2615,
    y2: 44.6284,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 59.7621,
    y1: 45.5801,
    x2: 67.1223,
    y2: 49.2602,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 71.06,
    y1: 51.098,
    x2: 79.9974,
    y2: 55.3038,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 29.2745,
    y1: 34.0161,
    x2: 68.7041,
    y2: 54.7824,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 29.8162,
    y1: 36.6542,
    x2: 61.36,
    y2: 56.369,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 66.6174,
    y1: 59.5229,
    x2: 77.132,
    y2: 66.0945,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 26.9431,
    y1: 37.718,
    x2: 31.3672,
    y2: 41.0611,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 36.1364,
    y1: 44.0215,
    x2: 55.5884,
    y2: 57.6905,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 25.6428,
    y1: 39.3065,
    x2: 29.8486,
    y2: 42.9866,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 31.4186,
    y1: 44.032,
    x2: 35.6244,
    y2: 47.4493,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 39.5687,
    y1: 50.6049,
    x2: 44.0373,
    y2: 54.285,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 47.1944,
    y1: 56.3902,
    x2: 50.6117,
    y2: 59.2817,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 51.3925,
    y1: 59.8018,
    x2: 69.2672,
    y2: 73.7337,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 70.5814,
    y1: 74.5219,
    x2: 75.313,
    y2: 78.202,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 25.3751,
    y1: 43.2454,
    x2: 31.6839,
    y2: 48.5027,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 32.9971,
    y1: 49.5541,
    x2: 41.9345,
    y2: 56.9143,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 41.9387,
    y1: 56.9171,
    x2: 56.6591,
    y2: 69.5346,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 22.2312,
    y1: 43.517,
    x2: 29.5914,
    y2: 50.3515,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 31.1723,
    y1: 51.6705,
    x2: 39.584,
    y2: 59.8193,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 40.6334,
    y1: 60.8686,
    x2: 45.8907,
    y2: 65.863,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 50.6267,
    y1: 70.3359,
    x2: 60.3527,
    y2: 80.0619,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 20.3976,
    y1: 45.3638,
    x2: 31.9636,
    y2: 56.9298,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 32.9521,
    y1: 58.0454,
    x2: 43.2701,
    y2: 68.7622,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 19.0983,
    y1: 46.695,
    x2: 28.5614,
    y2: 57.9982,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 29.6117,
    y1: 59.311,
    x2: 47.2236,
    y2: 80.0772,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 17.2677,
    y1: 48.0213,
    x2: 23.8393,
    y2: 56.9587,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 25.4171,
    y1: 58.5368,
    x2: 41.7147,
    y2: 80.8802,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 15.1757,
    y1: 49.6146,
    x2: 19.1187,
    y2: 55.9233,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 20.692,
    y1: 58.2832,
    x2: 31.2065,
    y2: 74.0551,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 33.5727,
    y1: 76.6844,
    x2: 46.1902,
    y2: 95.8735,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 13.339,
    y1: 50.9336,
    x2: 31.2138,
    y2: 81.4259,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 10.9794,
    y1: 52.2595,
    x2: 20.7054,
    y2: 70.9228,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 23.8558,
    y1: 76.4358,
    x2: 29.9017,
    y2: 87.2132,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 9.14581,
    y1: 53.0616,
    x2: 14.4031,
    y2: 64.8904,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 15.192,
    y1: 66.2047,
    x2: 21.7636,
    y2: 80.9251,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 6.78334,
    y1: 54.1215,
    x2: 19.138,
    y2: 84.6137,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 4.42222,
    y1: 55.1838,
    x2: 14.4111,
    y2: 83.836,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 1.79728,
    y1: 55.9841,
    x2: 10.9975,
    y2: 87.265,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: -0.0373255,
    y1: 56.532,
    x2: 1.01413,
    y2: 61.7893,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 2.06463,
    y1: 64.9408,
    x2: 5.74473,
    y2: 82.2899,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: -0.825585,
    y1: 67.0502,
    x2: 6.53462,
    y2: 105.954,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1888 -15.1659C40.5363 -12.5019 41.6828 -9.71749 42.6082 -6.83299L42.3702 -6.75662C44.1428 -1.23117 45.1006 4.66348 45.1006 10.7839C45.1006 16.9043 44.1428 22.799 42.3702 28.3244L42.6082 28.4008C41.6828 31.2853 40.5363 34.0697 39.1888 36.7337L38.9657 36.6209C33.5567 47.3142 24.8949 56.0598 14.2937 61.5355L14.4084 61.7576C11.7537 63.1288 8.97788 64.2959 6.10139 65.2383L6.02355 65.0007C0.505074 66.8087 -5.38586 67.786 -11.5039 67.786C-17.622 67.786 -23.513 66.8087 -29.0315 65.0007L-29.1093 65.2383C-31.9858 64.2959 -34.7616 63.1288 -37.4163 61.7576L-37.3016 61.5355C-47.9028 56.0598 -56.5646 47.3142 -61.9736 36.6209L-62.1967 36.7337C-63.5442 34.0697 -64.6907 31.2853 -65.6161 28.4008L-65.3781 28.3244C-67.1507 22.799 -68.1085 16.9043 -68.1085 10.7839C-68.1085 4.66348 -67.1507 -1.23117 -65.3781 -6.75661L-65.6161 -6.83299C-64.6907 -9.71749 -63.5442 -12.5019 -62.1966 -15.1659L-61.9736 -15.0531C-56.5646 -25.7465 -47.9028 -34.492 -37.3016 -39.9677L-37.4163 -40.1898C-34.7616 -41.561 -31.9858 -42.7281 -29.1093 -43.6705L-29.0315 -43.4329C-23.513 -45.2409 -17.622 -46.2183 -11.5039 -46.2183C-5.38585 -46.2183 0.505081 -45.2409 6.02356 -43.4329L6.10139 -43.6705C8.97789 -42.7281 11.7537 -41.561 14.4084 -40.1898L14.2937 -39.9677C24.8949 -34.492 33.5567 -25.7465 38.9657 -15.0531L39.1888 -15.1659Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    strokeDasharray: "40.1 10.1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLogoOsiris);
export default __webpack_public_path__ + "static/media/bgLogoOsiris.f738af3d996df20d27cbeb841e983790.svg";
export { ForwardRef as ReactComponent };